import { useEffect } from 'react'

/**
 * 제출 중 여부를 셸에 알려 탭 전환을 막는다. 응답 전에 패널이 언마운트되면 결과를 잃기 때문이다.
 * 언마운트 시 false 로 돌려 셸의 탭바가 잠긴 채 남지 않게 한다.
 */
export const useReportBusy = (busy: boolean, onBusyChange?: (busy: boolean) => void): void => {
  useEffect(() => {
    onBusyChange?.(busy)
    return () => onBusyChange?.(false)
  }, [busy, onBusyChange])
}
